"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2],{

/***/ 84002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(58408);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80684);
/* harmony import */ var load_google_maps_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42764);
/* harmony import */ var load_google_maps_api__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(load_google_maps_api__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18149);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56580);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70423);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(38726);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(89961);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63425);
/* harmony import */ var _tooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8282);
/* harmony import */ var _map_config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34357);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66686);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(30438);
/* harmony import */ var _redux_global_actions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79118);
/* harmony import */ var _utils_errorReporter__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(19663);
/* harmony import */ var _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87809);
























var Map = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(Map, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(Map);
    function Map() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(this, Map);
        var _this;
        _this = _super.apply(this, arguments);
        _this.map = null;
        _this.markers = [];
        _this.activeInfoWindow = null;
        _this.state = {
            displayMapButton: false,
            isMobile: false
        };
        _this.getActiveLocation = function(locations, activeLocationId) {
            return locations.find(function(location) {
                return location.id === activeLocationId;
            });
        };
        _this.clearMarkers = function(cb) {
            if (typeof google === "undefined") {
                return;
            }
            // Ensure the map is centered now that we'd resized div#map
            google.maps.event.trigger(_this.map, "resize");
            // Clear all previous markers
            _this.markers.forEach(function(marker) {
                marker.setMap(null);
            });
            _this.markers = [];
            // Add new locations to the map
            cb();
        };
        _this.deriveWindowInfoContent = function(location) {
            if (typeof google === "undefined") {
                return;
            }
            var strings = _this.props.strings;
            var contentString = strings && (0,_tooltip__WEBPACK_IMPORTED_MODULE_8__/* .mapTooltip */ .s)(location, function() {
                return _this.props.toggleFulfillmentModal(true, location, _koala_sdk__WEBPACK_IMPORTED_MODULE_1__/* .CONVEYANCE_TYPES.DELIVERY */ .P8.DELIVERY);
            }, _this.props.theme, strings, "t0.", _this.props.basketFulfillment, _this.props.theme);
            return new google.maps.InfoWindow({
                content: contentString
            });
        };
        _this.updateMapMarkers = function(locations, activeLocationId) {
            if (_this.activeInfoWindow !== null) {
                _this.activeInfoWindow.close();
            }
            var activeLocation = _this.getActiveLocation(locations, activeLocationId);
            _this.markers.forEach(function(marker) {
                var ref, ref1;
                var markerPosition = marker.getPosition();
                var isActive = Boolean((markerPosition === null || markerPosition === void 0 ? void 0 : markerPosition.lat()) === (activeLocation === null || activeLocation === void 0 ? void 0 : (ref = activeLocation.cached_data) === null || ref === void 0 ? void 0 : ref.latitude) && (markerPosition === null || markerPosition === void 0 ? void 0 : markerPosition.lng()) === (activeLocation === null || activeLocation === void 0 ? void 0 : (ref1 = activeLocation.cached_data) === null || ref1 === void 0 ? void 0 : ref1.longitude) && /** @TODO ensure that getTitle() doesn't return null. */ // @ts-expect-error
                marker.getTitle().includes(activeLocation === null || activeLocation === void 0 ? void 0 : activeLocation.label));
                var icon = _this.getMarker(isActive);
                if (isActive && !_this.state.isMobile && activeLocation) {
                    _this.activeInfoWindow = _this.deriveWindowInfoContent(activeLocation);
                    _this.activeInfoWindow.open(_this.map, marker);
                }
                marker.setIcon(icon);
            });
        };
        _this.getMarker = function() {
            var isActive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            var theme = _this.props.theme;
            if (theme.locations.map_icon && theme.locations.map_icon_active) {
                return isActive ? theme.locations.map_icon_active : theme.locations.map_icon;
            }
            return {
                path: "M0.399902 21.0595C0.399902 9.64069 9.57363 0.399994 20.7643 0.399994C31.9549 0.399994 41.1287 9.64069 40.9985 21.0595C40.9985 31.8737 23.0819 51.3109 21.2763 53.2697C21.2194 53.3314 21.1785 53.3758 21.1547 53.402C21.0245 53.534 20.8944 53.6 20.6992 53.6C20.504 53.6 20.3739 53.534 20.2438 53.402C20.2199 53.3758 20.1791 53.3314 20.1222 53.2697C18.3165 51.3109 0.399902 31.8737 0.399902 21.0595ZM21 29C25.9706 29 30 24.9706 30 20C30 15.0294 25.9706 11 21 11C16.0294 11 12 15.0294 12 20C12 24.9706 16.0294 29 21 29Z",
                fillColor: theme.global.primary_active_color,
                fillOpacity: isActive ? 1 : 0.5,
                strokeWeight: 0,
                rotation: 0,
                scale: 0.7,
                anchor: new google.maps.Point(20, 53)
            };
        };
        _this.drawLocations = function(locations, activeLocationId) {
            if (typeof google === "undefined") {
                return;
            }
            if (locations === null || locations === void 0 ? void 0 : locations.length) {
                locations.map(function(location) {
                    var ref, ref1;
                    var marker = new google.maps.Marker({
                        icon: _this.getMarker(location.id === activeLocationId),
                        map: _this.map,
                        position: {
                            // @ts-expect-error
                            lat: location === null || location === void 0 ? void 0 : (ref = location.cached_data) === null || ref === void 0 ? void 0 : ref.latitude,
                            // @ts-expect-error
                            lng: location === null || location === void 0 ? void 0 : (ref1 = location.cached_data) === null || ref1 === void 0 ? void 0 : ref1.longitude
                        },
                        title: "Click to expand details ".concat(location.label)
                    });
                    if (activeLocationId && location.id === activeLocationId && !_this.state.isMobile) {
                        // Don't open Google Maps InfoWindow popups on mobile
                        var activeLocation = _this.getActiveLocation(locations, activeLocationId);
                        if (!activeLocation) {
                            return;
                        }
                        _this.activeInfoWindow = _this.deriveWindowInfoContent(activeLocation);
                        _this.activeInfoWindow.open(_this.map, marker);
                    }
                    // Add click listener to marker so we can interact with them
                    google.maps.event.addListener(marker, "click", function() {
                        _this.props.setActiveLocation(location.id);
                        react_scroll__WEBPACK_IMPORTED_MODULE_6__/* .scroller.scrollTo */ .OK.scrollTo("Location-".concat(location.id), {
                            duration: 500,
                            smooth: true,
                            offset: -_constants_styles__WEBPACK_IMPORTED_MODULE_11__/* .LAYOUT.HEADERHEIGHT */ ._.HEADERHEIGHT
                        });
                    });
                    // Push the marker into the array
                    _this.markers.push(marker);
                });
                // Fit the map area to accommodate all markers
                _this.fitBounds();
            }
            _this.displayMapButton();
        };
        _this.getMapCenter = function() {
            var mapCenterCoords = [];
            // Fetch coordinates
            var w = _this.map.getBounds().getSouthWest().lng();
            var s = _this.map.getBounds().getSouthWest().lat();
            var centerLng = _this.map.getCenter().lng();
            var centerLat = _this.map.getCenter().lat();
            // Set center coordinates
            mapCenterCoords[0] = centerLat;
            mapCenterCoords[1] = centerLng;
            // Approximate degrees to miles
            var horizontalDistance = (centerLng - w) * 69.2;
            var verticalDistance = (centerLat - s) * 69.2;
            // Pick the larger distance - center to top or center to left
            var largestRadialDistance = Math.max(horizontalDistance, verticalDistance);
            _this.props.fetchCenterCoords(mapCenterCoords, largestRadialDistance);
            _this.setState({
                displayMapButton: false
            });
            // Fire Events
            (0,_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_13__/* .fireGaEvent */ .d4)(_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_13__/* .gaCats.findShop */ .m1.findShop, _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_13__/* .gaActions.mapSearchArea */ .cE.mapSearchArea);
        };
        _this.displayMapButton = function() {
            _this.map.addListener("dragend", function() {
                _this.setState({
                    displayMapButton: true
                });
                _this.props.showMapButton();
            });
        };
        return _this;
    }
    var _proto = Map.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
            var googleMaps, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            load_google_maps_api__WEBPACK_IMPORTED_MODULE_2___default()({
                                key: _this.props.theme.locations.map_key,
                                libraries: [
                                    _constants_global__WEBPACK_IMPORTED_MODULE_10__/* .GOOGLE_LIBRARIES.PLACES */ .Yv.PLACES
                                ]
                            })
                        ];
                    case 1:
                        googleMaps = _state.sent();
                        _this.map = new googleMaps.Map(document.getElementById("map"), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, _map_config__WEBPACK_IMPORTED_MODULE_9__/* .settings */ .X), {
                            styles: _map_config__WEBPACK_IMPORTED_MODULE_9__/* .styles */ .W,
                            zoomControlOptions: {
                                position: google.maps.ControlPosition.RIGHT_TOP
                            }
                        }));
                        _this.drawLocations(_this.props.locations, _this.props.activeLocationId);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        _utils_errorReporter__WEBPACK_IMPORTED_MODULE_21__/* .captureException */ .Tb(error);
                        console.error(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        // Determine whether mobile mode and set on state
                        _this.setState({
                            isMobile: window.matchMedia("(max-width: 767px)").matches
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this = this;
        // Ensure the map has initialized before attempting to modify it
        if (this.map) {
            // If locations change, reset the map
            if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_3___default()(prevProps.locations, this.props.locations)) {
                this.clearMarkers(function() {
                    _this.drawLocations(_this.props.locations, _this.props.activeLocationId);
                });
            } else if (prevProps.activeLocationId !== this.props.activeLocationId) {
                // If only the active index has changed, update the markers
                this.updateMapMarkers(this.props.locations, /** @TODO ensure that activeLocationId is defined. */ // @ts-expect-error
                this.props.activeLocationId);
            }
        }
    };
    _proto.fitBounds = function fitBounds() {
        if (typeof google === "undefined") {
            return;
        }
        var bounds = new google.maps.LatLngBounds();
        this.markers.forEach(function(marker) {
            var position = marker.getPosition();
            if (!position) {
                return;
            }
            if (marker.getVisible()) {
                bounds.extend(position);
            }
        });
        this.map.fitBounds(bounds);
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_7__/* .StyledMapOuter */ .Xi, {
            children: [
                this.state.displayMapButton && !this.props.hideMapButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_7__/* .StyledMapSearchButton */ .Qz, {
                    onClick: this.getMapCenter,
                    buttonTheme: "secondary",
                    children: "Search This Area"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_7__/* .StyledMap */ .OO, {
                    id: "map"
                })
            ]
        });
    };
    return Map;
}(react__WEBPACK_IMPORTED_MODULE_4__.Component);
var mapStateToProps = function(state) {
    return {
        basketFulfillment: state.app.basket.fulfillment,
        strings: state.app.cmsConfig.strings
    };
};
var mapDispatchToProps = {
    toggleFulfillmentModal: _redux_global_actions__WEBPACK_IMPORTED_MODULE_12__/* ["default"].toggleFulfillmentModal */ .Z.toggleFulfillmentModal
};
var connector = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__.connect)(mapStateToProps, mapDispatchToProps);
/* harmony default export */ __webpack_exports__["default"] = ((0,redux__WEBPACK_IMPORTED_MODULE_22__/* .compose */ .qC)(styled_components__WEBPACK_IMPORTED_MODULE_23__/* .withTheme */ .Zz, connector)(Map));


/***/ }),

/***/ 34357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ styles; },
/* harmony export */   "X": function() { return /* binding */ settings; }
/* harmony export */ });
var settings = {
    center: {
        lat: 42.877742,
        lng: -97.380979
    },
    draggable: true,
    mapTypeControl: false,
    maxZoom: 19,
    minZoom: 4,
    rotateControl: false,
    scrollwheel: true,
    streetViewControl: false,
    zoom: 4,
    zoomControl: true
};
var styles = [
    {
        featureType: "all",
        stylers: [
            {
                saturation: -40
            }
        ]
    },
    {
        elementType: "geometry.fill",
        featureType: "water",
        stylers: [
            {
                color: "#bfdcfd"
            }
        ]
    },
    {
        elementType: "geometry.fill",
        featureType: "landscape",
        stylers: [
            {
                color: "#f6f6f6"
            }
        ]
    },
    {
        elementType: "geometry",
        featureType: "road.highway",
        stylers: [
            {
                color: "#f6bb7b"
            },
            {
                saturation: 0
            }
        ]
    },
    {
        elementType: "labels",
        featureType: "poi.business",
        stylers: [
            {
                visibility: "off"
            }
        ]
    }, 
];


/***/ }),

/***/ 63425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OO": function() { return /* binding */ StyledMap; },
/* harmony export */   "Qz": function() { return /* binding */ StyledMapSearchButton; },
/* harmony export */   "Xi": function() { return /* binding */ StyledMapOuter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8782);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _components_uielements_primaryButton_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25167);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73393);
/* harmony import */ var _utils_safePolished__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68902);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  bottom: 0;\n  overflow: hidden;\n  position: sticky;\n  right: 0;\n  top: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  animation: fadein 0.5s;\n  background: ",
        ";\n  left: 10px;\n  max-width: 300px;\n  position: absolute;\n  top: 10px;\n  z-index: 2;\n\n  // Account for brands with a null secondary CTA bg\n  ",
        "\n\n  @keyframes fadein {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledMapOuter = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-eed2d624-0"
})(_templateObject());
var StyledMap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-eed2d624-1"
})(function(param) {
    var theme = param.theme;
    return {
        background: _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.BACKGROUNDGRAY */ .DM.BACKGROUNDGRAY,
        height: "100vh",
        overflow: "hidden",
        position: "relative",
        width: "100%",
        ".tooltip": {
            display: "flex",
            lineHeight: _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.LINE_HEIGHT */ ._.LINE_HEIGHT,
            padding: "5px 0px 5px 5px",
            maxWidth: "350px",
            minWidth: "300px",
            "> div": {
                "&:first-child": {
                    flex: 2
                },
                "&:last-child": {
                    display: "flex",
                    flexDirection: "column",
                    p: {
                        margin: "4px 0 0 ".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.GUTTER */ ._.GUTTER, "px"),
                        textAlign: "right",
                        a: {
                            fontFamily: theme.primary_font.medium.font_family,
                            textDecoration: "underline"
                        }
                    }
                }
            },
            h3: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                display: "inline-block",
                margin: "0 0px 8px",
                paddingRight: "24px",
                position: "relative"
            }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.location_card.secondary_font, [
                "font_family",
                "font_size",
                "font_style",
                "color",
                "line_height"
            ], {
                font_size: function(value) {
                    return typeof value === "number" ? value : 16;
                },
                line_height: function(value) {
                    return typeof value === "number" ? value : 20;
                },
                color: function(value) {
                    if (value && (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .getContrast */ .mj)(_constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.WHITE */ .DM.WHITE, String(value)) > 4.5) {
                        return value;
                    }
                    return _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.TEXT */ .DM.TEXT;
                }
            })),
            p: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                margin: 0
            }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.location_card.font, [
                "font_family",
                "font_weight",
                "font_style",
                "color"
            ], {
                color: function(value) {
                    // @TODO: `getFontStyles` type seems mangled
                    // @ts-expect-error: value type is wrong
                    if (value && (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .getContrast */ .mj)(_constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.WHITE */ .DM.WHITE, value) > 4.5) {
                        return value;
                    }
                    return _constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.TEXT */ .DM.TEXT;
                }
            })), {
                a: {
                    color: "inherit",
                    "&:hover": {
                        textDecoration: "underline"
                    }
                },
                "&.tooltip-distance": {
                    fontStyle: "italic",
                    marginTop: "5px"
                }
            }),
            ".tooltip-cta": {
                transition: "all 150ms linear",
                borderRadius: "".concat(theme.buttons.primary_button_border_radius, "px"),
                cursor: "pointer",
                display: "inline-block",
                fontFamily: theme.primary_font.medium.font_family,
                fontSize: "12px",
                marginBottom: "10px",
                padding: "10px 20px 8px",
                textAlign: "center",
                "&.tooltip-cta-primary": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    background: theme.buttons.primary_button_background_color,
                    border: "1px solid ".concat(theme.buttons.primary_button_border_color)
                }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.buttons.primary_font, [
                    "color",
                    "font_family",
                    "font_style",
                    "font_weight",
                    "line_height", 
                ], {
                    color: function(value) {
                        if (value === "revert" || value === null) {
                            return (0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_8__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_6__/* .readableColor */ .XV)(theme.buttons.primary_button_background_color);
                        }
                        return value;
                    }
                })), {
                    "&:hover": {
                        background: "".concat((0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_8__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_6__/* .darken */ ._j)(0.025, theme.buttons.primary_button_background_color))
                    }
                }),
                "&.tooltip-cta-secondary": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    background: theme.buttons.secondary_button_background_color,
                    border: "1px solid ".concat(theme.buttons.secondary_button_border_color)
                }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.buttons.secondary_font, [
                    "color",
                    "font_family",
                    "font_style",
                    "font_weight",
                    "line_height", 
                ], {
                    color: function(value) {
                        if (value === "revert" || value === null) {
                            return (0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_8__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_6__/* .readableColor */ .XV)(theme.buttons.secondary_button_background_color);
                        }
                        return value;
                    }
                })), {
                    "&:hover": {
                        background: "".concat((0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_8__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_6__/* .darken */ ._j)(0.025, theme.buttons.secondary_button_background_color))
                    }
                }),
                "&.tooltip-cta-knockout": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    background: theme.buttons.knockout_button_background_color,
                    border: "1px solid ".concat(theme.buttons.knockout_button_border_color)
                }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.buttons.knockout_font, [
                    "color",
                    "font_family",
                    "font_style",
                    "font_weight",
                    "line_height", 
                ], {
                    color: function(value) {
                        if (value === "revert" || value === null) {
                            return theme.buttons.knockout_button_border_color;
                        }
                        return value;
                    }
                })), {
                    "&:hover": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        background: "".concat((0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_8__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_6__/* .darken */ ._j)(0.025, theme.buttons.knockout_button_background_color))
                    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.buttons.knockout_font, [
                        "color"
                    ], {
                        /** @FIXME font refactor. color isn't actually null, it defaults to revert in the config screen. Should we treat `revert` like `null` */ color: function(value) {
                            return value ? (0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_8__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_6__/* .darken */ ._j)(0.025, value) : "inherit";
                        }
                    }))
                })
            }
        },
        ".tooltip-info": {
            paddingRight: "10px"
        },
        ".mapboxgl-popup-content": {
            padding: "15px 20px 15px 15px",
            ".mapboxgl-popup-close-button": {
                top: "5px"
            }
        },
        "@media (max-width: 767px)": {
            height: "calc(\n        100vh - ".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.MOBILE_HEADERHEIGHT */ ._.MOBILE_HEADERHEIGHT, "px -\n          ").concat(_constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.MOBILE_MAP_LOCATION_CARD_HEIGHT */ ._.MOBILE_MAP_LOCATION_CARD_HEIGHT, "px -\n          ").concat(_constants_styles__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.MOBILE_LIST_MAP_FOOTER_HEIGHT */ ._.MOBILE_LIST_MAP_FOOTER_HEIGHT, "px\n      )")
        }
    };
});
var StyledMapSearchButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_components_uielements_primaryButton_styles__WEBPACK_IMPORTED_MODULE_1__/* .StyledPrimaryButton */ .D).withConfig({
    componentId: "sc-eed2d624-2"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.buttons.secondary_button_background_color || "rgba(255, 255, 255, 0.8)";
}, function(param) {
    var theme = param.theme;
    return !theme.buttons.secondary_button_background_color && "\n    &:hover {\n      background: ".concat((0,_utils_safePolished__WEBPACK_IMPORTED_MODULE_8__/* .safePolished */ .F)(polished__WEBPACK_IMPORTED_MODULE_6__/* .darken */ ._j)(0.025, theme.buttons.secondary_button_background_color || "rgba(255, 255, 255, 0.7)"), ";\n    }\n  ");
});


/***/ }),

/***/ 8282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ mapTooltip; }
/* harmony export */ });
/* harmony import */ var _constants_cta__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32159);
/* harmony import */ var _constants_locations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56296);
/* harmony import */ var _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87809);
/* harmony import */ var _utils_locations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52591);
/* harmony import */ var _utils_stringHelpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60738);





/** @TODO this entire component needs to be refactored. */ var deriveCTAValues = function(strings, location, position, positionId, basketFulfillment, config) {
    var globalValue = (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_4__/* .safelyGetString */ .bc)(strings, "location_ctas.".concat(position, "_value"), location);
    var globalLabel = (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_4__/* .safelyGetString */ .bc)(strings, "location_ctas.".concat(position, "_label"), location);
    var ref = (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_4__/* .reconcileCustomAttributeWithGlobalValue */ .zS)(// @ts-expect-error @TODO improve typing of custom attributes
    location.attributes, positionId, globalValue, globalLabel), label = ref.label, value = ref.value;
    var ctaObject = {
        value: value,
        label: label,
        interpolatedValue: (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_4__/* .interpolateLocationCtaValue */ .hF)(value, location, config).finalValue
    };
    // If we have an existing delivery address AND the CTA is a delivery trigger, treat the CTA
    // like the pickup button and just navigate to store menu page - the reconciliation modal will handle the rest
    if ((basketFulfillment === null || basketFulfillment === void 0 ? void 0 : basketFulfillment.address) && value === _constants_cta__WEBPACK_IMPORTED_MODULE_0__/* .CTA.DELIVERY_URL */ .M.DELIVERY_URL) {
        ctaObject.interpolatedValue = (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_4__/* .interpolateLocationCtaValue */ .hF)(_constants_cta__WEBPACK_IMPORTED_MODULE_0__/* .CTA.PICKUP_URL */ .M.PICKUP_URL, location, config).finalValue;
    }
    return ctaObject;
};
var derivePrimaryCtas = function(ctaObject, trackerName, location, gaAction, classes, hideDeliveryTrigger, basketFulfillment) {
    var ref;
    var escapedLocationLabel = (ref = location.label) === null || ref === void 0 ? void 0 : ref.replace(/'/g, "");
    var gaEvent = "ga('".concat(trackerName || "", "send', 'event', '").concat(_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_2__/* .gaCats.order */ .m1.order, "', '").concat(gaAction, "', '").concat(escapedLocationLabel, "')");
    if (ctaObject.value === _constants_cta__WEBPACK_IMPORTED_MODULE_0__/* .CTA.DELIVERY_URL */ .M.DELIVERY_URL && !(basketFulfillment === null || basketFulfillment === void 0 ? void 0 : basketFulfillment.address)) {
        return '<button\n        class="'.concat(classes, '"\n        data-css-override="MapTooltipPrimaryButton"\n        aria-label="Order delivery from ').concat(ctaObject.label, '"\n        onclick="toggleFulfillmentModal(); ').concat(gaEvent, '"\n        ').concat(hideDeliveryTrigger && 'style="display: none"', "\n      >\n        ").concat(ctaObject.label, "\n      </button>");
    }
    if (ctaObject.label && ctaObject.value && location.provider_enabled) {
        return '<a\n        href="'.concat(ctaObject.interpolatedValue, '"\n        class="').concat(classes, '"\n        onclick="').concat(gaEvent, '"\n        data-css-override="MapTooltipPrimaryButton"\n      >\n        ').concat(ctaObject.label, "\n      </a>");
    }
    return "";
};
var mapTooltip = function(location, toggleFulfillmentModal, theme, strings, trackerName, basketFulfillment, config) {
    var ref, ref1, ref2, ref3, ref4;
    // We should only render the Koala-specific delivery trigger if the location supports delivery. Otherwise, we should render nothing
    var hideDeliveryTrigger = !location.supports_delivery;
    // Location inactive
    var disabled = !location.provider_enabled;
    var locationInactive = (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_4__/* .safelyGetString */ .bc)(strings, "locations.location_inactive");
    // Derive primary CTA values
    // @ts-expect-error
    var primaryCtaObject = !disabled && deriveCTAValues(strings, location, "primary", _constants_locations__WEBPACK_IMPORTED_MODULE_1__/* .LOCATION_ATTRIBUTE_POSITIONS.PRIMARY_ORDER_CTA */ .NB.PRIMARY_ORDER_CTA, basketFulfillment, config);
    // @ts-expect-error
    var secondaryCtaObject = !disabled && deriveCTAValues(strings, location, "secondary", _constants_locations__WEBPACK_IMPORTED_MODULE_1__/* .LOCATION_ATTRIBUTE_POSITIONS.SECONDARY_ORDER_CTA */ .NB.SECONDARY_ORDER_CTA, basketFulfillment, config);
    // Location cross street
    var getCrossStreetDisplayString = function() {
        var ref;
        if (!((ref = theme.locations) === null || ref === void 0 ? void 0 : ref.cross_street) || !location.cross_street) {
            return "";
        }
        var crossStreetLabel = (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_4__/* .safelyGetString */ .bc)(strings, "locations.cross_street_label");
        return crossStreetLabel ? "".concat(crossStreetLabel + " ").concat(location.cross_street, "<br />") : "".concat(location.cross_street, "<br />");
    };
    var primaryCtaTheme = (ref = theme.location_card) === null || ref === void 0 ? void 0 : ref.primary_button_theme;
    var secondaryCtaTheme = (ref1 = theme.location_card) === null || ref1 === void 0 ? void 0 : ref1.secondary_button_theme;
    window.toggleFulfillmentModal = function() {
        return toggleFulfillmentModal();
    };
    var ref5, _zip_code, ref6;
    return '\n    <div class="tooltip">\n      <div class="tooltip-info">\n        <h3>'.concat((ref2 = location.cached_data) === null || ref2 === void 0 ? void 0 : ref2.label, '</h3>\n        <p>\n          <a\n            href="').concat((0,_utils_locations__WEBPACK_IMPORTED_MODULE_3__/* .googleMapsUrl */ .Y_)(location.cached_data), '"\n            target="_blank"\n          >\n            ').concat(location.street_address, "<br />\n            ").concat(getCrossStreetDisplayString(), "\n            ").concat(location.city, ", ").concat((ref5 = (ref3 = location.cached_data) === null || ref3 === void 0 ? void 0 : ref3.state) !== null && ref5 !== void 0 ? ref5 : "", " ").concat((_zip_code = location.zip_code) !== null && _zip_code !== void 0 ? _zip_code : "", "\n          </a>\n          <br />\n          <span>\n          ").concat((ref6 = (ref4 = location.cached_data) === null || ref4 === void 0 ? void 0 : ref4.phone_number) !== null && ref6 !== void 0 ? ref6 : "", '\n          </span>\n        </p>\n\n        <p class="tooltip-distance">\n          ').concat(location.distance_miles ? "".concat(Math.round(location.distance_miles * 100) / 100, " miles away") : "", "\n        </p>\n\n        ").concat(disabled ? '<p style="margin-top: 10px"><i>'.concat(locationInactive, "</i></p>") : "", "\n      </div>\n      <div>\n        ").concat(derivePrimaryCtas(primaryCtaObject, trackerName, location, _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_2__/* .gaActions.mapPrimaryCta */ .cE.mapPrimaryCta, "tooltip-cta tooltip-cta-".concat(primaryCtaTheme), hideDeliveryTrigger, basketFulfillment), "\n        ").concat(derivePrimaryCtas(secondaryCtaObject, trackerName, location, _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_2__/* .gaActions.mapSecondaryCta */ .cE.mapSecondaryCta, "tooltip-cta tooltip-cta-".concat(secondaryCtaTheme), hideDeliveryTrigger, basketFulfillment), "\n      </div>\n    </div>\n  ");
};


/***/ })

}]);